import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ToastIconPipe } from '../../pipes/toast-icon.pipe';
import { ToastService } from '../../../core/services/toast.service';

import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'avcc-toast-container',
  templateUrl: './toast.html',
  styleUrls: ['./toast.scss'],
  imports: [CommonModule, ToastIconPipe],
  animations: [
    trigger('toastStack', [
      transition('* <=> *', [
        query(
          ':enter',
          [
            stagger(50, [
              style({
                opacity: 0,
                transform: 'translateY(20px) scale(0.95)',
              }),
              animate(
                '250ms cubic-bezier(0.22, 1, 0.36, 1)',
                style({
                  opacity: 1,
                  transform: 'translateY(0) scale(1)',
                }),
              ),
            ]),
          ],
          { optional: true },
        ),
        query(
          ':leave',
          [
            style({
              opacity: 1,
              transform: 'translateY(0)',
            }),
            animate(
              '200ms ease-in',
              style({
                opacity: 0,
                transform: 'translateY(30px) scale(0.95)',
              }),
            ),
          ],
          { optional: true },
        ),
      ]),
    ]),
  ],
})
export class Toast {
  private readonly toastService = inject(ToastService);

  /**
   * Observable; stream of active toasts
   */
  toasts = toSignal(this.toastService.toasts$);

  /**
   * Triggers the removal logic for a specific toast based on its unique ID.
   */
  remove(id: number) {
    this.toastService.remove(id);
  }
}
